export class Enquiryno {
    Id : number ;
    EnquiryNo : number;
}
